export type Status =
	| "Active"
	| "Success"
	| "Error"
	| "Warning"
	| "Ready"
	| "Inactive"
	| "Cancelled"
	| "Expired"
	| "Draft"
	| "Terminated"
	| "Pending"
	| "Default"
	| "Uploaded"
	| "Processed"
	| "New"
	| "NotReady";

export const getStatusThemeColor = (status: Status) => {
	const statusRecord: Record<
		Status,
		"primary" | "secondary" | "success" | "info" | "warning" | "error"
	> = {
		Active: "success",
		Success: "success",
		Ready: "success",
		Inactive: "secondary",
		Pending: "warning",
		Cancelled: "error",
		Expired: "warning",
		Draft: "secondary",
		Terminated: "error",
		Error: "error",
		Default: "secondary",
		Uploaded: "success",
		Processed: "success",
		New: "secondary",
		NotReady: "secondary",
		Warning: "warning",
	};

	return statusRecord[status] || "default";
};

export const getStatusTitle = (status: Status) => {
	const statusTitleRecord: Record<Status, string> = {
		Active: "Aktivní",
		Success: "Úspěšný",
		Ready: "Připravený",
		Inactive: "Neaktivní",
		Pending: "Čekající",
		Cancelled: "Zrušený",
		Expired: "Expirovaný",
		Draft: "Návrh",
		Terminated: "Ukončený",
		Error: "Chyba",
		Default: "Výchozí",
		Uploaded: "Nahraný",
		Processed: "Zpracovaný",
		New: "Nový",
		NotReady: "Není připraveno",
		Warning: "",
	};

	return statusTitleRecord[status] || status;
};
